import type { ClientAnswer } from '@/api/orderDetails'

export const CLIENT_ANSWERS_COLLAPSE_THRESHOLD = 5

const UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i

function extractUuidFromString(str: string | null | undefined): string | null {
  if (str == null || typeof str !== 'string') return null
  const match = str.match(UUID_REGEX)
  return match ? match[0] : null
}

export function getUuidFromAnswer(answer: ClientAnswer): string | null {
  return (
    extractUuidFromString(answer.templateQuestionId) ??
    extractUuidFromString(answer.questionCode) ??
    null
  )
}

export interface GroupedAnswers {
  groups: { uuid: string; answers: ClientAnswer[] }[]
  ungrouped: ClientAnswer[]
}

export function groupAnswersByUuid(answers: ClientAnswer[]): GroupedAnswers {
  const byUuid = new Map<string, ClientAnswer[]>()
  const ungrouped: ClientAnswer[] = []
  const groupOrder: string[] = []

  for (const answer of answers) {
    const uuid = getUuidFromAnswer(answer)
    if (uuid) {
      if (!byUuid.has(uuid)) {
        groupOrder.push(uuid)
        byUuid.set(uuid, [])
      }
      byUuid.get(uuid)!.push(answer)
    } else {
      ungrouped.push(answer)
    }
  }

  const groups = groupOrder.map((uuid) => ({ uuid, answers: byUuid.get(uuid)! }))
  return { groups, ungrouped }
}
